import React from 'react';
import styled from 'styled-components';
import Logo from '../common/logo';
import TagButton from '../tagButton';
import Footer from '../common/footer';
import { AppearText } from '../common/appear';

const DEFAULT_TEXT = 'Only the Best Solutions on the Market, '
                    + 'only the Top Insurance Partners';

const Wrapper = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding-bottom: 100px;
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 120px;
    padding-bottom: 120px;
    @media (max-width: 1200px) {
        padding: 0 57px;
        padding-bottom: 80px;
        padding-left: 0;
        padding-right: 0;
    }
    @media (max-width: 600px) {
        padding: 0;
        padding-bottom: 80px;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
`;

const CenteredText = styled.h3`
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 120%;
    /* or 43px */
    max-width: 577px;
    color: #0064BA;
    text-align: center;

    @media (max-width: 1200px) {
        font-size: 28px;
        line-height: 120%;
        /* or 34px */
    }
`;

const CenteredTextWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
    @media (max-width: 1200px) {
        margin-top: 10px;
        padding-left: 100px;
        padding-right: 100px;
    }
    @media (max-width: 600px) {
        padding: 0;
    }
`;

const LogoWrapper = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    margin-right: 50px;
    img {
        max-width: 100%;
    }
    @media (max-width: 1200px) {
        left: 0;
    }
    @media (max-width: 600px) {
        position: relative;
        display: block;
        width: 86px;
        height: auto;
        img {
            width: 86px;
            height: auto;
        }
    }
`;

const WrapperHomeFooter = ({
    centeredText = DEFAULT_TEXT,
    langKey = 'en'
}) => (
    <>
        <Wrapper>
            {
                /* <LogoWrapper>
                    <Logo />
                </LogoWrapper>
                */
            }
            <CenteredTextWrapper>
                <AppearText>
                    <CenteredText>{centeredText}</CenteredText>
                </AppearText>
            </CenteredTextWrapper>
            <TagButton
                image={1}
                left
                link={`/${langKey}/personal`}
            />
            <TagButton
                image={2}
                boldText="Commercial"
                normalText="Insurance Products"
                link={`/${langKey}/commercial`}
                right
            />
        </Wrapper>
        <Footer />
    </>
);


export default WrapperHomeFooter;
